import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IFeatureFlags } from 'store/types/featureFlagsTypes';

const initialState = {
  featureFlags: null,
};

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags(state, action: PayloadAction<IFeatureFlags>) {
      state.featureFlags = action?.payload;
    },
  },
});

export const { setFeatureFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
